<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'iss-wo-common.label.service-location' | translate"
  [readonly]="readonly"
  [forceTypeahead]="forceTypeahead"
  [withAll]="withAll"
  [loading]="loading"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [multi]="multi"
  [clearable]="clearable"
/>
